import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetPunchoutUserIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { createContext } from "react";

export function getUserIdentityDataView(state: ApplicationStateTKCCP, parameter: GetPunchoutUserIdentityApiParameter) {
    const data = getDataView(state.dataPunchoutUserIdentity, parameter);
    return data;
}

export const UserIdentityDataViewContext = createContext<ReturnType<typeof getUserIdentityDataView>>({
    value: undefined,
    isLoading: false,
});
